import React from 'react'
import './copyrigt.com.css'

function Copyright({ position, bgColor }) {
    return (
        <div    
            className='copyrigt-container' 
            style={
                position === 'fixed'
                ? {position: 'fixed', padding: '0 1rem', background: bgColor} 
                : 'relative'
                ? {position: 'relative', background: bgColor} 
                : null
            }
        >
            <p className="t-copyright align-center">Copyright © 2022 National Healthcare Systems Company <br/> Limited All rights reserved</p>
        </div>
    )
}

export default Copyright